


















import Vue from 'vue';
import { FieldActionButtonStateModel } from '@/types/models';

export default Vue.extend({
  name: 'FieldActionButton',
  data() {
    return {
      show: false
    };
  },
  props: {
    actionButtonState: {
      type: Object as () => FieldActionButtonStateModel,
      required: true
    },
    buttonId: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onActionButtonClicked() {
      this.$emit('actionButtonClicked');
    }
  },
  computed: {
    actionButtonId(this: any) {
      return `${'actionButton-'}${this.buttonId}`;
    },
    showTooltip(this: any) {
      return !this.actionButtonState.isDisabled && !this.isDisabled && this.show;
    },
    actionButtonStateTooltip(this: any) {
      return this.actionButtonState.isDisabled || this.isDisabled ? 'No Document' : this.actionButtonState.tooltip;
    }
  }
});
